module.exports = __webpack_public_path__ + "static/media/banff-58.55e01b90.jpg";